/**
 * RealEstateSearchLayer用の追加項目同期システム
 * PropertySelectionGridとRealEstateSearchポップアップ間で追加項目データを同期するためのユーティリティ
 */

import { createIndexedPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const REAL_ESTATE_SEARCH_ADDITIONAL_FIELDS_UPDATE_EVENT =
  "updateRealEstateSearchAdditionalFields";

const { dispatch, addListener } =
  createIndexedPropertyGridPopupSyncSystem<string>(
    REAL_ESTATE_SEARCH_ADDITIONAL_FIELDS_UPDATE_EVENT
  );

/**
 * RealEstateSearchの追加項目更新イベントを発火する
 * @param index 不動産検索結果のインデックス
 * @param additionalFields 更新する追加項目（JSON文字列）
 */
export const dispatchRealEstateSearchAdditionalFieldsUpdate = (
  index: number,
  additionalFields: string
): void => {
  dispatch(index, additionalFields);
};

/**
 * RealEstateSearchの追加項目更新イベントリスナーを追加する
 * @param targetIndex リスナーを登録する対象のインデックス
 * @param callback 追加項目が更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addRealEstateSearchAdditionalFieldsUpdateListener = (
  targetIndex: number,
  callback: (additionalFields: string) => void
): (() => void) => {
  return addListener(targetIndex, callback);
};
